const EDC = 'https://w3id.org/edc/v0.0.1/ns/';

export const DataAddressProperty = {
  authCode: `${EDC}authCode`,
  authKey: `${EDC}authKey`,
  baseUrl: `${EDC}baseUrl`,
  body: `${EDC}body`,
  header: `header`,
  contentType: `${EDC}contentType`,
  mediaType: `${EDC}mediaType`,
  method: `${EDC}method`,
  pathSegments: `${EDC}pathSegments`,
  proxyBody: `${EDC}proxyBody`,
  proxyMethod: `${EDC}proxyMethod`,
  proxyPath: `${EDC}proxyPath`,
  proxyQueryParams: `${EDC}proxyQueryParams`,
  queryParams: `${EDC}queryParams`,
  secretName: `${EDC}secretName`,
  type: `${EDC}type`,
};
